import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipe.module';
import { BepsCategoriesComponent } from './admin/beps-categories/beps-categories.component';
import { BepsCountriesComponent } from './admin/beps-countries/beps-countries.component';
import { BepsQuartersComponent } from './admin/beps-quarters/beps-quarters.component';
import { CbcDeleteVarianceDataComponent } from './components/cbc-delete-variance-data/cbc-delete-variance-data.component';
import { CbcCreateRecDataComponent } from './components/cbc-create-rec-data/cbc-create-rec-data.component';
import { CbcCreateFsElimDataComponent } from './components/cbc-create-fs-elim-data/cbc-create-fs-elim-data.component';
import { CbcReportingComponent } from './components/cbc-reporting/cbc-reporting.component';
import { CbcSchdATbl3Component } from './components/cbc-reporting/cbc-schd-a-tbl3/cbc-schd-a-tbl3.component';
import { CbcTbl2RefreshComponent } from './components/cbc-reporting/cbc-tbl2-refresh/cbc-tbl2-refresh.component';
import { CbcCbyeRefreshComponent } from './components/cbc-reporting/cbc-cbye-refresh/cbc-cbye-refresh.component';
import { CbcEditAcctTaggingComponent } from './components/cbc-reporting/cbc-edit-acct-tagging/cbc-edit-acct-tagging.component';
import { CbcDeleteDataByMeComponent } from './components/cbc-reporting/cbc-delete-data-by-me/cbc-delete-data-by-me.component';
import { CbcStatelessRefreshComponent } from './components/cbc-reporting/cbc-stateless-refresh/cbc-stateless-refresh.component';
import { CbcStatelessPushComponent } from './components/cbc-reporting/cbc-stateless-push/cbc-stateless-push.component';
import { BepsRollforwardComponent } from './components/cbc-reporting/beps-rollforward/beps-rollforward.component';
import { PushCbcDataToEfileComponent } from './components/cbc-reporting/push-cbc-data-to-efile/push-cbc-data-to-efile.component';

@NgModule({
  declarations: [
    BepsCategoriesComponent,
    BepsQuartersComponent,
    BepsCountriesComponent,
    CbcDeleteVarianceDataComponent,
    CbcCreateRecDataComponent,
    CbcCreateFsElimDataComponent,
    CbcReportingComponent,
    CbcSchdATbl3Component,
    CbcTbl2RefreshComponent,
    CbcCbyeRefreshComponent,
    CbcEditAcctTaggingComponent,
    CbcDeleteDataByMeComponent,
    CbcStatelessRefreshComponent,
    CbcStatelessPushComponent,
    BepsRollforwardComponent,
    PushCbcDataToEfileComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    SharedPipesModule,
  ],
  exports: [
    BepsCategoriesComponent,
    BepsQuartersComponent,
    BepsCountriesComponent,
    CbcDeleteVarianceDataComponent,
    CbcCreateRecDataComponent,
    CbcCreateFsElimDataComponent,
    CbcReportingComponent,
    CbcSchdATbl3Component,
    CbcTbl2RefreshComponent,
    CbcCbyeRefreshComponent,
    CbcEditAcctTaggingComponent,
    CbcDeleteDataByMeComponent,
    CbcStatelessRefreshComponent,
    CbcStatelessPushComponent,
    BepsRollforwardComponent,
    PushCbcDataToEfileComponent
  ],
  providers: [],
  schemas: [NO_ERRORS_SCHEMA]
})
export class CBCModule {}
